import React, { useState, useEffect } from "react";
import IDateRangePicker from "./IDateRangePicker";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "./restyle_react-datepicker.css";
import { Button } from "@appComponents/Button";

const DateRangePickerV2 = (props: IDateRangePicker) => {
  const [activePicker, setActivePicker] = useState<"from" | "to">("from");

  const [localStartDate, setLocalStartDate] = useState<Date | null>(
    props.startDate || null
  );
  const [localEndDate, setLocalEndDate] = useState<Date | null>(
    props.endDate || null
  );

  const handleLocalChange = (date: Date) => {
    if (activePicker === "from") {
      setLocalStartDate(date);

      if (localEndDate && moment(date).isAfter(localEndDate)) {
        setLocalEndDate(date);
      }
    } else {
      setLocalEndDate(date);

      if (localStartDate && moment(date).isBefore(localStartDate)) {
        setLocalStartDate(date);
      }
    }
  };

  const handleDone = () => {
    props.updateState({
      startDate: localStartDate,
      endDate: localEndDate,
    });
    props.onClose?.();
  };

  const handleClear = () => {
    setLocalStartDate(null);
    setLocalEndDate(null);
    props.onClose?.();

    props.updateState({
      startDate: null,
      endDate: null,
    });
  };

  const selectedDate = activePicker === "from" ? localStartDate : localEndDate;

  return (
    <div className="flex flex-col justify-end sm:gap-5 mt-4">
      <div className="mb-4 sm:mb-0">
        <DatePicker
          inline
          selected={selectedDate}
          onChange={handleLocalChange}
          minDate={props.minDate}
          maxDate={props.maxDate}
          startDate={localStartDate}
          endDate={localEndDate}
          selectsStart={activePicker === "from"}
          selectsEnd={activePicker === "to"}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      </div>

      <div className="flex gap-3 justify-between">
        <div className="flex flex-1 flex-col gap-1">
          <p className="text-sm font-medium">From</p>
          <input
            readOnly
            className={`cursor-pointer border border-gray-200 text-sm px-3 py-2 rounded focus:outline-none ${
              activePicker === "from" ? "ring-2 ring-purple-600" : ""
            }`}
            placeholder={moment().format("D MMM YYYY")}
            value={
              localStartDate ? moment(localStartDate).format("D MMM YYYY") : ""
            }
            onClick={() => setActivePicker("from")}
          />
        </div>

        <div className="flex flex-1 flex-col gap-1">
          <p className="text-sm font-medium">To</p>
          <input
            readOnly
            className={`cursor-pointer border border-gray-200 text-sm px-3 py-2 rounded focus:outline-none ${
              activePicker === "to" ? "ring-2 ring-purple-600" : ""
            }`}
            placeholder={moment().format("D MMM YYYY")}
            value={
              localEndDate ? moment(localEndDate).format("D MMM YYYY") : ""
            }
            onClick={() => setActivePicker("to")}
          />
        </div>
      </div>

      <div className="flex flex-col gap-2 mt-2">
        <Button className="w-full" isPrimary onClick={handleDone}>
          Done
        </Button>
        <Button className="w-full" onClick={handleClear}>
          Clear
        </Button>
      </div>
    </div>
  );
};

export default DateRangePickerV2;
